var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_uid.js
// module id = 70
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.2.5.1@core-js/library/modules/_uid.js